

/// <reference path="EventItem.ts" />

// Generated class EventItemLine_ManagedObject

class EventItemLine_ManagedObject extends EventItem
{

    // Property: quantity
    set quantity(value:number) {
        this.setValueForKey(value, 'quantity');
    }
    get quantity():number {
        return this.valueForKey('quantity');
    }
    set quantityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'quantity');
    }
    get quantityPrimitiveValue():number {
        return this.primitiveValueForKey('quantity');
    }

    // Property: totalAmount
    set totalAmount(value:number) {
        this.setValueForKey(value, 'totalAmount');
    }
    get totalAmount():number {
        return this.valueForKey('totalAmount');
    }
    set totalAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'totalAmount');
    }
    get totalAmountPrimitiveValue():number {
        return this.primitiveValueForKey('totalAmount');
    }

    // Property: unitPrice
    set unitPrice(value:number) {
        this.setValueForKey(value, 'unitPrice');
    }
    get unitPrice():number {
        return this.valueForKey('unitPrice');
    }
    set unitPricePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'unitPrice');
    }
    get unitPricePrimitiveValue():number {
        return this.primitiveValueForKey('unitPrice');
    }
    // Relationship: menu
    set menu(value:Menu) {
        this.setValueForKey(value, 'menu');
    }
    get menu():Menu {
        return this.valueForKey('menu') as Menu;
    }
    // Relationship: phase
    set phase(value:EventItemPhase) {
        this.setValueForKey(value, 'phase');
    }
    get phase():EventItemPhase {
        return this.valueForKey('phase') as EventItemPhase;
    }
    // Relationship: product
    set product(value:Product) {
        this.setValueForKey(value, 'product');
    }
    get product():Product {
        return this.valueForKey('product') as Product;
    }
}
